import { CustomProductFormActions, initialOrder } from '../reducer';

export function addRow(dispatch, data) {
  return () => {
    const value = [...data, { ...initialOrder, key: data.length }];
    dispatch({ type: CustomProductFormActions.SET_FORM_VALUE, payload: value });
  };
}
